import { Component, Input, OnInit } from "@angular/core";
import { TemplateSegment } from "ng/src/app/templates/shared/template.model";
import { AppStateService } from "ng/src/app/core/services/app-state.service";
import { Utils } from "ng/src/app/core/utils";
import { TemplateService } from "ng/src/app/templates/shared/template.service";
import { NoteMetadata } from "../note-metadata.model";

@Component({
	selector: 'lb-note-location-map',
	templateUrl: './note-location-map.component.html',
	// Hide warning message popup that appears for development-only (no API key) map
	styles: [':host ::ng-deep .map-container > :nth-child(2) { display: none }']
})
export class NoteLocationMapComponent implements OnInit {
	@Input() locationData!: NoteMetadata[];
	@Input() templateId!: number;
	@Input() showMap = false;

	constructor(
		private templateService: TemplateService
	) { }

	devOnlyMap = AppStateService.isLocalHost;
	featureCollection!: GeoJSON.FeatureCollection<GeoJSON.Point>;
	map!: google.maps.Map;
	mapOptions!: google.maps.MapOptions;
	templateSegments: { [id: number]: TemplateSegment } = {};

	ngOnInit() {
		this.setFeatureCollection();

        this.mapOptions = {
			center: this.getMapCenter(),
			mapTypeId: 'hybrid',
            zoom: 18
		};
	}

	initializeMap(event: any) {
		this.map = event.map;

		this.map.data.addGeoJson(this.featureCollection);
		this.templateService.getSubTemplatesByTemplateId(this.templateId).subscribe(segments => {
			segments.forEach(ts => this.templateSegments[ts.id] = ts);

			this.map.data.setStyle(this.getFeatureTitle);
		});
	}
	
	private getMapCenter() {
		const bounds = new google.maps.LatLngBounds();

		for (const feature of this.featureCollection.features) {
			const [lng, lat] = feature.geometry.coordinates;

			bounds.extend(new google.maps.LatLng(lat, lng));
		}

		return bounds.getCenter();
	}

	private setFeatureCollection() {
		this.locationData.forEach(ld => {
			const featureCollection: GeoJSON.FeatureCollection<GeoJSON.Point> = JSON.parse(ld.stringValue!);
			for (const feature of featureCollection.features) {
				feature.properties = feature.properties || {};
				feature.properties.user = `${ld.createdBy.firstName} ${ld.createdBy.lastName}`;
			}
			this.featureCollection = (!this.featureCollection)
				? featureCollection
				: {
					...this.featureCollection,
					...featureCollection
				}
		});
	}
	
	private getFeatureTitle = (feature: google.maps.Data.Feature): google.maps.Data.StyleOptions => {
		let rolloverText = '';

		const title = feature.getProperty('title');

		if (title)
			rolloverText = title;
		else {
			const timestamp = feature.getProperty('timestamp'),
				stId = feature.getProperty('subTemplateId');

			if (timestamp)
				rolloverText = Utils.fullMonthMeridiem(timestamp) + ' - ';
			
			rolloverText += this.templateSegments[stId]?.longName || '[unknown]';
		}

		const user = feature.getProperty('user');
		if (user)
			rolloverText += ' ' + user;

		return { title: rolloverText };
	}

	static loadGoogleMapsAPI() {
		// See: https://developers.google.com/maps/documentation/javascript/overview#Dynamic

		let src = 'https://maps.googleapis.com/maps/api/js';
		
		if (!AppStateService.isLocalHost) {
			const mapsApiKey = 'AIzaSyBxRYBpJ-SaKpXnj1TK0acXtQ7EI7m75Wk';
			src += `?key=${mapsApiKey}`;
		}

		const script = document.createElement('script');
		script.src = src;
		script.async = true;

		document.head.appendChild(script);
	}
}